<template>
  <!-- Slot for Details -->
  <template v-if="mode === 'details'">
    <img 
      v-tooltip 
      src="@/assets/icons/info.svg" 
      class="popoverButton" 
      title="Detail" 
      @click="$emit('detail', rowData)" 
    />
  </template>

  <!-- Slot for Edit/Delete -->
  <template v-else-if="mode === 'actions'">
    <div class="d-flex flex-nowrap align-items-center">
      <img v-if="allowEdit"
        v-tooltip 
        src="@/assets/icons/edit.png" 
        class="popoverButton action" 
        title="Edit" 
        @click="$emit('edit', rowData)" 
      />
      <img 
        v-tooltip 
        src="@/assets/icons/delete.svg" 
        class="popoverButton action" 
        title="Delete" 
        @click="$emit('remove', rowData)" 
      />
    </div>
  </template>
</template>

<script setup>
import vTooltip from '@/directives/tooltip';
const props = defineProps({
  mode: String,    // 'details' or 'actions'
  rowData: Object,  // The data for the specific row
  allowEdit: { type: Boolean, default: true },
});
defineEmits(['detail', 'edit', 'remove']);
</script>

<style scoped>
/* .pointer { cursor: pointer; }
.action { height: 20px; width: auto; } */
</style>
